/* RIDE Cyclery — Brand UI behaviors
   - Mobile nav toggle
   - Announcement bar rotation (already CSS-driven; this swaps active item on small screens)
   - Before/after image slider (vanilla JS)
   - Inquiry form basic validation
*/
(function () {
  'use strict';

  // ---------- Mobile menu toggle ----------
  function initMobileMenu() {
    document.querySelectorAll('[data-ride-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.querySelector(btn.getAttribute('data-target'));
        if (!target) return;
        var open = target.hasAttribute('open');
        if (open) {
          target.removeAttribute('open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          target.setAttribute('open', '');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // ---------- Announcement rotator (small screens) ----------
  function initAnnouncementRotator() {
    document.querySelectorAll('[data-ride-announcement]').forEach(function (track) {
      var items = track.querySelectorAll('.ride-announcement__item');
      if (items.length < 2) return;
      var idx = 0;
      // CSS handles desktop (shows all). On mobile, fade through each.
      function tick() {
        if (window.innerWidth >= 750) {
          items.forEach(function (i) { i.style.display = ''; });
          return;
        }
        items.forEach(function (i, k) { i.style.display = (k === idx) ? 'inline-flex' : 'none'; });
        idx = (idx + 1) % items.length;
      }
      tick();
      setInterval(tick, 4500);
      window.addEventListener('resize', tick);
    });
  }

  // ---------- Before/after slider ----------
  function initBeforeAfter() {
    document.querySelectorAll('[data-ride-ba]').forEach(function (root) {
      var afterWrap = root.querySelector('[data-ride-ba-after]');
      var handle = root.querySelector('[data-ride-ba-handle]');
      if (!afterWrap || !handle) return;

      var dragging = false;
      function setPct(pct) {
        pct = Math.max(0, Math.min(100, pct));
        afterWrap.style.width = pct + '%';
        handle.style.left = pct + '%';
      }
      function fromEvent(e) {
        var rect = root.getBoundingClientRect();
        var clientX = (e.touches && e.touches[0]) ? e.touches[0].clientX : e.clientX;
        var x = clientX - rect.left;
        var pct = (x / rect.width) * 100;
        setPct(pct);
      }
      function start(e) { dragging = true; fromEvent(e); e.preventDefault(); }
      function move(e) { if (!dragging) return; fromEvent(e); }
      function end() { dragging = false; }

      root.addEventListener('mousedown', start);
      root.addEventListener('touchstart', start, { passive: false });
      window.addEventListener('mousemove', move);
      window.addEventListener('touchmove', move, { passive: true });
      window.addEventListener('mouseup', end);
      window.addEventListener('touchend', end);

      // keyboard
      root.setAttribute('tabindex', '0');
      root.setAttribute('role', 'slider');
      root.setAttribute('aria-valuemin', '0');
      root.setAttribute('aria-valuemax', '100');
      root.setAttribute('aria-valuenow', '50');
      root.addEventListener('keydown', function (e) {
        var cur = parseFloat(afterWrap.style.width || '50');
        if (e.key === 'ArrowLeft') { setPct(cur - 4); root.setAttribute('aria-valuenow', Math.round(cur - 4)); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setPct(cur + 4); root.setAttribute('aria-valuenow', Math.round(cur + 4)); e.preventDefault(); }
      });

      setPct(50);
    });
  }

  // ---------- Inquiry form (light validation + success flag) ----------
  function initInquiry() {
    document.querySelectorAll('[data-ride-inquiry]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // Let the form submit natively to Shopify (handled by contact form action),
        // but block if required fields are blank to give a faster UX message.
        var required = form.querySelectorAll('[required]');
        var ok = true;
        required.forEach(function (f) {
          if (!f.value || !String(f.value).trim()) {
            ok = false;
            f.style.outline = '2px solid #1A1A1A';
          } else {
            f.style.outline = '';
          }
        });
        if (!ok) {
          e.preventDefault();
          var err = form.querySelector('[data-ride-inquiry-error]');
          if (err) err.textContent = 'Please fill in all required fields.';
        }
      });
    });
  }

  // Wait for DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMobileMenu();
      initAnnouncementRotator();
      initBeforeAfter();
      initInquiry();
    });
  } else {
    initMobileMenu();
    initAnnouncementRotator();
    initBeforeAfter();
    initInquiry();
  }
})();
